import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useTranslation } from 'react-i18next';
import config from '../../../../config/config';
import styles from './CustomBrowserPicker.module.css';
import CustomImage from '../CustomImage/CustomImage';
import ImageErrorBoundary from '../CustomImage/ImageErrorBoundary';
import missingFile from '../../../../assets/images/missing-file-min.png';

const LoaderColor = {
  colorPrimary: `${styles.loadBarPrimary}`,
};

const browsers = {
  firefox: 'Firefox',
  chrome: 'Chrome',
  edge: 'Edge',
  legacyEdge: 'Edge (Legacy)',
  safari: 'Safari',
};

const preventDrag = (event) => {
  event.preventDefault();
};

const CustomBrowserPicker = (props) => {
  const { commonStore } = props;
  const [selectedBrowser, setSelectedBrowser] = React.useState('');
  const { t } = useTranslation();

  let selectedGif;
  let alt;
  switch (selectedBrowser) {
    case browsers.firefox:
      selectedGif = `${config.publicUrl}/firefox.gif`;
      alt = 'Firefox';
      break;
    case browsers.chrome:
      selectedGif = `${config.publicUrl}/chrome.gif`;
      alt = 'Chrome';
      break;
    case browsers.edge:
      selectedGif = `${config.publicUrl}/edge.gif`;
      alt = 'Edge';
      break;
    case browsers.legacyEdge:
      selectedGif = `${config.publicUrl}/legacyEdge.gif`;
      alt = 'Edge (Legacy)';
      break;
    case browsers.safari:
      selectedGif = `${config.publicUrl}/safari.gif`;
      alt = 'Safari';
      break;
    default:
      break;
  }

  const handleOnClick = (e) => {
    commonStore.setCustomModalTitle('');

    setSelectedBrowser(e.currentTarget.dataset.value);
  };

  return (
    <>
      {selectedGif ? (
        <div className={styles.browserPickerContainer}>
          <ImageErrorBoundary
            fallback={
              <img
                src={missingFile}
                alt={t('Common.MissingFile')}
                height="192"
                onDragStart={preventDrag}
              />
            }
          >
            <React.Suspense
              fallback={<CircularProgress size={251} thickness={2} classes={LoaderColor} />}
            >
              <CustomImage url={selectedGif} alt={alt} />
            </React.Suspense>
          </ImageErrorBoundary>
        </div>
      ) : (
        <React.Fragment>
          <div className={styles.subTitleContainer}>
            {t('CustomBrowserPicker.SelectYourBrowser')}
          </div>

          <div className={styles.browserPickerContainer}>
            <button type="button" onClick={handleOnClick} data-value={browsers.firefox}>
              <span className={[styles.logo, styles.firefoxLogo].join(' ')} />

              {browsers.firefox}
            </button>

            <button type="button" onClick={handleOnClick} data-value={browsers.chrome}>
              <span className={[styles.logo, styles.chromeLogo].join(' ')} />

              {browsers.chrome}
            </button>

            <button type="button" onClick={handleOnClick} data-value={browsers.edge}>
              <span className={[styles.logo, styles.edgeLogo].join(' ')} />

              {browsers.edge}
            </button>

            <button type="button" onClick={handleOnClick} data-value={browsers.legacyEdge}>
              <span className={[styles.logo, styles.edgeLegacyLogo].join(' ')} />

              {browsers.legacyEdge}
            </button>

            <button type="button" onClick={handleOnClick} data-value={browsers.safari}>
              <span className={[styles.logo, styles.safariLogo].join(' ')} />

              {browsers.safari}
            </button>
          </div>
        </React.Fragment>
      )}
    </>
  );
};
CustomBrowserPicker.whyDidYouRender = true;
CustomBrowserPicker.displayName = 'CustomBrowserPicker';

export default React.memo(CustomBrowserPicker);
